import { useState } from 'react';

import { TDealColumn } from '@crm/entities/deals-board';

import { useEditColumnMutation, useCreateColumnMutation } from '../../api';
import { FALLBACK_COLUMN_BG_COLOR } from '../../config';
import { TEditColumnFormState } from '../../ui/EditColumn/model/editColumnForm.schema';

export const useEditColumn = (columnId?: TDealColumn['id']) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [previewColumnColor, setPreviewColumnColor] = useState<string | null>(null);
    const [previewColumnBgColor, setPreviewColumnBgColor] = useState<string | null>(null);
    const editColumnMutation = useEditColumnMutation();
    const createColumnMutation = useCreateColumnMutation();

    const openEditMode = () => {
        setIsEditMode(true);
    };

    const closeEditMode = () => {
        setPreviewColumnColor(null);
        setPreviewColumnBgColor(null);
        setIsEditMode(false);
    };

    const changePreviewColumnColor = (color: string, bgColor: string | undefined) => {
        setPreviewColumnColor(color);
        setPreviewColumnBgColor(bgColor ?? FALLBACK_COLUMN_BG_COLOR);
    };

    const handleEditColumnSubmit = async (data: TEditColumnFormState) => {
        if (!columnId) {
            return;
        }

        await editColumnMutation.mutateAsync(
            {
                columnId,
                color: data.color,
                title: data.title,
            },
            {
                onSuccess: closeEditMode,
            }
        );
    };

    const handleCreateColumnSubmit = async (data: TEditColumnFormState) => {
        await createColumnMutation.mutateAsync(
            {
                color: data.color,
                title: data.title,
            },
            {
                onSuccess: closeEditMode,
            }
        );
    };

    return {
        previewColumnColor,
        previewColumnBgColor,
        isEditMode,
        isEditPending: editColumnMutation.isPending,
        closeEditMode,
        changePreviewColumnColor,
        handleEditColumnSubmit,
        handleCreateColumnSubmit,
        openEditMode,
    };
};
